import React, { createContext, FC } from 'react';

import { Feature } from 'api';
import { useProtectedClient } from 'hooks';

export interface IWithFeatures {
  features: {
    legacyAuthDomain: boolean;
    skipOnboardingSelectGroups: boolean;
    moderatorDashboard: boolean;
    msteams: boolean;
    nativePostV2: boolean;
    slack: boolean;
    webNotifications: boolean;
    clientInvitationsV2: boolean;
    userManagementV2: boolean;
  };
}

const FeaturesContext = createContext<IWithFeatures>({
  features: {
    legacyAuthDomain: false,
    skipOnboardingSelectGroups: false,
    moderatorDashboard: false,
    msteams: false,
    nativePostV2: false,
    slack: false,
    webNotifications: false,
    clientInvitationsV2: false,
    userManagementV2: false,
  },
});

const FeaturesProvider: FC = ({ children }) => {
  const client = useProtectedClient();

  const features = client.features || [];
  const clientFeatures: IWithFeatures['features'] = {
    legacyAuthDomain: features.includes(Feature.LegacyAuthDomain),
    skipOnboardingSelectGroups: features.includes(Feature.SkipOnboardingSelectGroups),
    moderatorDashboard: features.includes(Feature.ModeratorDashboard),
    msteams: features.includes(Feature.MsTeams),
    nativePostV2: features.includes(Feature.NativePostV2),
    slack: features.includes(Feature.Slack),
    webNotifications: features.includes(Feature.WebNotifications),
    clientInvitationsV2: features.includes(Feature.ClientInvitationsV2),
    userManagementV2: features.includes(Feature.UserManagementV2),
  };

  return (
    <FeaturesContext.Provider value={{ features: clientFeatures }}>
      {children}
    </FeaturesContext.Provider>
  );
};

export { FeaturesContext, FeaturesProvider };
